import { jsx as _jsx } from "react/jsx-runtime";
import CIcon from "@coreui/icons-react";
import { CButton } from "@coreui/react";
import { cilLowVision } from "@coreui/icons";
const ShowPasswordButton = ({ showPassword, setShowPassword, }) => {
    return (_jsx(CButton, Object.assign({ type: "button", color: "secondary", variant: "outline", onClick: () => setShowPassword(!showPassword) }, { children: _jsx(CIcon, { icon: cilLowVision }) })));
};
export default ShowPasswordButton;
